<template>
    <footer class="footer_zone position-relative p-b-32 p-t-32 p-l-20 p-r-20 separator-t-g2">
        <div class="d-flex justify-content-center">
            <div class="col-md-10 col-lg-10 col-xl-8 col-xxl-8">
                <div class="row justify-content-around">
                    <div class="footer_left col-sm-4 col-md-4 col-lg-4">
                        <div class="css_StyleText4">
                            {{LS("База знаний сервиса")}}&nbsp;<strong>PuzzleBot&nbsp;://</strong><br>
                            <a href="https://puzzlebot.top" class="css_link css_StyleText12">www.puzzlebot.top</a>
                        </div>
                    </div>
                    <div class="footer_center col-sm-4 col-md-4 col-lg-4">
                        <div class="d-flex">
                            <div class="style_cursor text-center"><a href="tg://resolve?domain=iampuzzlebot" target="_blank"><img src="../../assets/icons/tg_social.svg" hspace="5" class="icon_tg_social"></a></div>
                            <div class="m-l-8 style_cursor text-center"><a href="https://vk.com/iampuzzlebot" target="_blank"><img src="../../assets/icons/vk_social.svg" hspace="5" class="icon_vk_social"></a></div>
                            <div class="m-l-8 style_cursor text-center"><a href="https://twitter.com/iampuzzlebot" target="_blank"><img src="../../assets/icons/twitter_social.svg" hspace="5" class="icon_twitter_social"></a></div>
                        </div>
                    </div>
                    <div class="footer_right col-sm-4 col-md-4 col-lg-4">
                        <div class="">
                            <div class="css_StyleText3">{{LS("Поддержка пользователей")}}:<br>
                                <span class="css_link css_StyleText12">
                                  <a href="https://t.me/helpmepuzzlebot?start=link_u5Xcg1I1vo" target="_blank" class="css_link css_StyleText12">@helpmepuzzlebot</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import {LS} from "@/shared/services/translate";
export default {

    setup() {
      return {
        LS
      }
    }
}
</script>

<style scoped>
.footer_zone{
    bottom: 0px;
}
@media (max-width: 767px){
  .footer_left, .footer_center, .footer_right{
    margin-left: 0px !important;
  }
  .footer_left, .footer_center{
    margin-bottom: 32px !important;
  }
}
</style>